export const BASE_URL = process.env.REACT_APP_PUBLIC_URL;
// "REACT_APP_PUBLIC_URL": "http://localhost:8888"
